import $ from "jquery";

export const archiveViewAllBtn = () => {
  $(".js-archive-view-all-btn").on("click", function (e) {
    e.preventDefault();
    $(".page-archive__list li").each(function (index) {
      // 非表示のものだけを対象にする
      if ($(this).css("display") === "none") {
        $(this).fadeIn(600);
      }
    });
    $(this).fadeOut(); // ボタン自体もフェードアウトして削除（必要に応じて変更）
  });
};
